import React from "react";

// Dnya logo — uses the approved mosaic coin image (Section 4 — Branding)
// Rendering rules:
//  - Aspect ratio preserved (no stretch)
//  - No CSS color filters
//  - Crisp on retina via srcSet
//  - The bottom mic button wraps this and adds the pulsing ring animation
export default function Logo({ size = 48, alt = "Dnya logo", style = {} }) {
  return (
    <img
      src="/assets/dnya-logo.png"
      srcSet={[
        `/assets/dnya-logo-64.png 64w`,
        `/assets/dnya-logo-128.png 128w`,
        `/assets/dnya-logo-192.png 192w`,
        `/assets/dnya-logo-512.png 512w`,
        `/assets/dnya-logo.png 1024w`,
      ].join(", ")}
      sizes={`${size}px`}
      width={size}
      height={size}
      alt={alt}
      decoding="async"
      style={{
        display: "block",
        width: size,
        height: size,
        objectFit: "contain",
        borderRadius: "50%",
        ...style,
      }}
    />
  );
}
